import React, { useEffect } from 'react'
import { Route, useLocation, useNavigate } from 'react-router-dom';
import MainInvoice from '../Views/Web/Invoice/MainInvoice';
import MainInvoicesIncoming from '../Views/Web/Invoice/InvoicesIncoming/MainInvoicesIncoming';
import InvoiceIncomingIndex from '../Views/Web/Invoice/InvoicesIncoming/Index';
import CreateInvoiceIncoming from '../Views/Web/Invoice/InvoicesIncoming/CreateInvoiceIncoming';
import EditInvoiceIncoming from '../Views/Web/Invoice/InvoicesIncoming/EditInvoiceIncoming ';
import ViewInvoiceIncoming from '../Views/Web/Invoice/InvoicesIncoming/ViewInvoiceIncoming ';
import MainInvoicesOutgoing from '../Views/Web/Invoice/InvoicesOutgoing/MainInvoicesOutgoing';
import InvoiceOutgoingIndex from '../Views/Web/Invoice/InvoicesOutgoing/Index';
import CreateInvoiceOutgoing from '../Views/Web/Invoice/InvoicesOutgoing/CreateInvoiceOutgoing';
import EditInvoiceOutgoing from '../Views/Web/Invoice/InvoicesOutgoing/EditInvoiceOutgoing ';
import ViewInvoiceOutgoing from '../Views/Web/Invoice/InvoicesOutgoing/ViewInvoiceOutgoing ';
import { Wrapper } from '../Components/Utils/roles';

const InvoiceRoutes = () => {
     const location = useLocation();
      const navigate = useNavigate();
    
      useEffect(() => {
        if (location.pathname === "/invoice" || location.pathname === "/invoice/") {
          navigate("/page-not-found");
        }
      }, [location]);
  return (
    <Route path="invoice" element={<MainInvoice/>}>
     <Route path="invoice_incoming" element={<MainInvoicesIncoming />}>
        <Route
          index
          element={
            <Wrapper accessKey={"invoice_in_view"} Component={InvoiceIncomingIndex} />
          }
        />
        <Route
          path="create"
          element={
            <Wrapper accessKey={"invoice_in_create"} Component={CreateInvoiceIncoming} />
          }
        />
        <Route
          path="edit/:incomingEditId"
          element={<Wrapper accessKey={"invoice_in_edit"} Component={EditInvoiceIncoming} />}
        />
        <Route
          path="view/:incomingViewId"
          element={<Wrapper accessKey={"invoice_in_view"} Component={ViewInvoiceIncoming} />}
        />
      </Route>
      <Route path="invoice_outgoing" element={<MainInvoicesOutgoing />}>
        <Route
          index
          element={
            <Wrapper accessKey={"invoice_out_view"} Component={InvoiceOutgoingIndex} />
          }
        />
        <Route
          path="create"
          element={
            <Wrapper accessKey={"invoice_out_create"} Component={CreateInvoiceOutgoing} />
          }
        />
        <Route
          path="edit/:outgoingEditId"
          element={<Wrapper accessKey={"invoice_out_edit"} Component={EditInvoiceOutgoing} />}
        />
        <Route
          path="view/:outgoingViewId"
          element={<Wrapper accessKey={"invoice_out_view"} Component={ViewInvoiceOutgoing} />}
        />
      </Route>
    </Route>
  )
}

export default InvoiceRoutes